import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  name: 'Eirini Vassou',
  role: 'Chief Strategist',
  quote: 'Architecting review ecosystems since 2014.',
  initials: 'EV'
}, {
  name: 'Theron Kask',
  role: 'Technical SEO Lead',
  quote: "Schema markup is a language. I'm fluent.",
  initials: 'TK'
}, {
  name: 'Liora Meven',
  role: 'Monetization Director',
  quote: 'Every click has a value. I find it.',
  initials: 'LM'
}, {
  name: 'Costas Zervas',
  role: 'Content Architect',
  quote: 'Reviews are stories. I give them structure.',
  initials: 'CZ'
}];
export function Team() {
  return <section id="team" className="py-32 bg-gameu-card border-t border-gameu-elevated" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-159">
          <h2 className="font-serif text-5xl md:text-6xl text-gameu-text mb-6" data-id="element-160">
            The Strategists
          </h2>
          <p className="text-gameu-muted text-lg max-w-2xl" data-id="element-161">
            A specialized unit of technical marketers and monetization experts
            based in Cyprus.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-162">
          {team.map((member, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gameu-base p-6 border border-gameu-elevated" data-id="element-163">
              <div className="w-16 h-16 rounded-full bg-gameu-elevated flex items-center justify-center mb-6 border border-gameu-muted/20" data-id="element-164">
                <span className="font-serif text-xl text-gameu-accent" data-id="element-165">
                  {member.initials}
                </span>
              </div>
              <h3 className="text-xl font-medium text-gameu-text mb-1" data-id="element-166">
                {member.name}
              </h3>
              <p className="text-xs font-bold tracking-wider uppercase text-gameu-muted mb-4" data-id="element-167">
                {member.role}
              </p>
              <p className="text-sm text-gameu-muted italic border-l-2 border-gameu-accent pl-3 py-1" data-id="element-168">
                "{member.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}